import Moon from '@assets/icons/moon.svg'
import { Icon } from './Icon'

export const MoonIcon = Icon(Moon)
